<template>
  <div>
    <el-upload
      v-if="type === 'image'"
      class="mr-20 avatar-uploader"
      accept=".jpg,.png,.jpeg,.bmp,.gif"
      :action="action"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :data="formData"
      :style="{
        height: uiHeight + 'px',
        width: uiWidth + 'px'
      }"
    >
      <div v-if="error" class="action-bar notice">{{ error }}</div>
      <div v-else-if="notice" class="action-bar notice">{{ notice }}</div>
      <div v-else-if="value && showSizeInfo" class="action-bar notice">建议尺寸 {{ width || '800' }} * {{ height || '800' }}</div>
      <img
        v-if="value"
        :src="value"
        class="avatar"
        :style="{
          height: uiHeight + 'px',
          width: uiWidth + 'px'
        }"
      >
      <div
        v-else
        class="avatar-uploader-icon"
        :style="{
          height: uiHeight + 'px',
          width: uiWidth + 'px'
        }"
      >
        <i class="el-icon-plus" />
        <span class="info">添加上传图片</span>
        <span class="info" v-if="showSizeInfo">建议尺寸 {{ width || '800' }} * {{ height || '800' }}</span>
      </div>
      <div v-if="remove && value" class="action-bar remove">
        <i v-if="prev" class="left el-icon-arrow-left" @click.prevent.stop="handlePrev" />
        <i class="el-icon-delete" @click.prevent.stop="handleRemove"/>
        <i v-if="next" class="right el-icon-arrow-right" @click.prevent.stop="handleNext" />
      </div>
    </el-upload>
    <el-upload
      v-else
      class="file-uploader"
      :action="action"
      :on-success="handleSuccess"
      :before-upload="beforeUpload"
      :data="formData"
    >
      <el-button v-if="value" slot="trigger" size="small" type="primary" plain="">重新上传</el-button>
      <el-button v-else slot="trigger" size="small" type="primary">点击上传</el-button>
      <el-link v-if="value" type="success" :href="value" target="_blank" class="ml-10">查看文件</el-link>
      <el-link v-if="remove && value" type="danger" class="ml-10" @click.prevent.stop="handleRemove">移除</el-link>
      <div slot="tip" class="el-upload__tip">{{ notice }}</div>
    </el-upload>
  </div>
</template>

<script>
import { getOssToken, uploadFile } from '@/api/file.js'
import { getNewFileName } from '@/utils/index.js'
export default {
  props: {
    // 默认链接地址
    value: {
      type: String,
      default: ''
    },
    // 提示文本
    notice: {
      type: String,
      default: ''
    },
    // 是否显示删除按钮
    remove: {
      type: Boolean,
      default: false
    },
    // 是否显示上一张按钮
    prev: {
      type: Boolean,
      default: false
    },
    // 是否显示下一张按钮
    next: {
      type: Boolean,
      default: false
    },
    // 图片宽度限制
    width: {
      type: Number,
      default: 0
    },
    // 图片高度限制
    height: {
      type: Number,
      default: 0
    },
    showSizeInfo: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      error: null,
      uiHeight: 146,
      action: '',
      formData: {}
    }
  },
  computed: {
    uiWidth: function() {
      const definedWidth = this.width ? this.width : 800
      const definedHeight = this.height ? this.height : 800
      return (definedWidth * 146) / definedHeight
    }
  },
  methods: {
    // 成功上传后的回调操作，本次未触发
    handleSuccess(file) {
      this.$emit('input', URL.createObjectURL(file.raw))
    },
    handleRemove() {
      this.$emit('input', null)
      this.$emit('no-remove')
    },
    handlePrev() {
      this.$emit('prev')
    },
    handleNext() {
      this.$emit('next')
    },
    // 上传文件，由于存在无法触发原始上传的操作
    // 原因待排查，排查后可以换成框架原始上传操作
    // 这里直接在获取到文件后手动上传，并通知上层modal
    beforeUpload(file) {
      this.error = null
      if (file.size > 2048000) {
        this.error = '单个文件大小不能超过2M'
        this.$message('单个文件大小不能超过2M')

        setTimeout(() => {
          this.error = null
        }, 2000)

        return false
      }
      getOssToken('media/upload/').then(responseData => {
        const filename = responseData.dir + getNewFileName(file.name)
        uploadFile(responseData, file, filename).then(() => {
          this.$emit('input', responseData.host + '/' + filename)
          this.$emit('on-change', responseData.host + '/' + filename)
        })
      })
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  background: $slateGray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  position: relative;
  .action-bar {
    position: absolute;
    left: 0;
    right: 0;
    line-height: 26px;
    background-color: rgba($color: #000000, $alpha: 0.4);
    text-align: center;
    color: #fff;
  }
  .notice {
    top: 0;
  }
  .remove {
    bottom: 0;
    // display: flex;
    // justify-content: space-around;
    font-size: 20px;
    i {
      line-height: 26px;
    }
    .left {
      position: absolute;
      left: 2px;
    }
    .right {
      position: absolute;
      right: 2px;
    }
  }
}
.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .el-icon-plus {
    margin-bottom: 10px;
  }
  .info {
    font-size: 13px;
  }
}
.avatar {
  border-radius: 6px;
  display: block;
}
</style>

